export const CTopFooterLinks = {
  field: `
      fragment topFooterLinks on topFooterLinks_MatrixField {
        ... on topFooterLinks_links_Entry {
          id
          linkName
          linkUrl
          linkPosition
        }
      }
    `,
}
